<div class="login-wrapper">
	<h3 class="title">{{TEXTS[type]}}</h3>
</div>
